import { enableActivation } from 'core/handlers/ActivationHandler'
import { enableOrientation } from 'core/handlers/OrientationHandler'
import { enableParallax } from 'core/handlers/ParallaxHandler'
import { enableResize } from 'core/handlers/ResizeHandler'

export function enableDisplay(container, data) {
  const visible = {}

  container.name = data.name
  container.interactive = data.interactive || container.interactive
  container.x = data.x || 0
  container.y = data.y || 0

  container.visibility = function (value, tag) {
    visible[tag] = value
    container.visible = Object.values(visible).every((x) => x)
  }
  if (data.resize && data.type !== 'AnimationSpine') {
    enableResize(container, data.orientation)
  }
  else if (data.orientation) {
    enableOrientation(container, data)
  }
  if (data.paralax) {
    enableParallax(container)
  }

  enableActivation(container)
}

export function enableIncludeEntity(container, data) {
  const visible = {}

  container.name = data.name
  container.interactive = data.interactive || container.interactive
  container.x = data.x || 0
  container.y = data.y || 0
  container.data = data.properties

  container.visibility = function (value, tag) {
    visible[tag] = value
    container.visible = Object.values(visible).every((x) => x)
  }

  enableActivation(container)
}

export function enableInclude(container, data) {
  const visible = {}

  container.name = data.name
  container.interactive = data.interactive || container.interactive

  container.x = data.orientation ? data.orientation.land.x : 0
  container.y = data.orientation ? data.orientation.land.y : 0
  container.visibility = function (value, tag) {
    visible[tag] = value
    container.visible = Object.values(visible).every((x) => x)
  }

  enableActivation(container)
}
